import { ofType, Epic } from "redux-observable";
import { merge, mergeMap, of } from "rxjs";
import { IAction } from "../../../interface/action.interface";
import { IRootState } from "../../../redux/root.reducer";
import { validateAccessToken } from "../../../service/api";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { download } from "../service/downloader";
import {
    DownloadActionType,
    IDownloadAction,
    downloadStartAction,
} from "./download.actions";

export const downloadEpic: Epic<IAction, IAction, IRootState> = (action$) =>
    merge(
        action$.pipe(
            ofType<IDownloadAction, DownloadActionType.DOWNLOAD_START>(
                DownloadActionType.DOWNLOAD_START,
            ),
            mergeMap((action) => {
                validateAccessToken(
                    selectAuthTokens(),
                    (accessToken: string | undefined) => {
                        download(
                            action.payload.downloadUrl,
                            accessToken,
                            action.payload.requestBody,
                        );
                        return of();
                    },
                    () => of(),
                ).subscribe();
                return [];
            }),
        ),
        action$.pipe(
            ofType<IDownloadAction, DownloadActionType.DOWNLOAD_DATA_BROWSER>(
                DownloadActionType.DOWNLOAD_DATA_BROWSER,
            ),
            mergeMap((action) => [
                downloadStartAction(
                    "/lists/download",
                    JSON.stringify(action.payload.request),
                ),
            ]),
        ),
        action$.pipe(
            ofType<IDownloadAction, DownloadActionType.DOWNLOAD_LIST_LOCATIONS>(
                DownloadActionType.DOWNLOAD_LIST_LOCATIONS,
            ),
            mergeMap((action) => [
                downloadStartAction(
                    `/locations/download/${action.payload.listId}`,
                ),
            ]),
        ),
        action$.pipe(
            ofType<
                IDownloadAction,
                DownloadActionType.DOWNLOAD_SUBLIST_LOCATIONS
            >(DownloadActionType.DOWNLOAD_SUBLIST_LOCATIONS),
            mergeMap((action) => [
                downloadStartAction(
                    `/locations/download/with-sublists/${action.payload.listId}`,
                ),
            ]),
        ),
        action$.pipe(
            ofType<
                IDownloadAction,
                DownloadActionType.DOWNLOAD_LIST_SNAPSHOT_LOCATIONS
            >(DownloadActionType.DOWNLOAD_LIST_SNAPSHOT_LOCATIONS),
            mergeMap((action) => [
                downloadStartAction(
                    `/locations/download/snapshot/${action.payload.listId}/${action.payload.date}`,
                ),
            ]),
        ),
    );
